import { PATH_LANDING } from '@ui/config/paths';
import { ZKSYNC_ENABLED } from '@veno-app/wallet';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useCoinMode } from './useCoinMode';

export const useRedirectFromHiddenPage = () => {
  const globalCoinMode = useCoinMode();
  const router = useRouter();

  useEffect(() => {
    if (globalCoinMode === 'eth' && !ZKSYNC_ENABLED) router.push(PATH_LANDING);
  }, [globalCoinMode, router]);
};
